<template>
  <main-template>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 mb-2">{{ escola.descricao }}</h2>
        <e-label>Pesquise uma unidade escolar aqui</e-label>
        <v-autocomplete
          v-model="escola"
          :items="this.franquiasList"
          item-text="descricao"
          item-value="id"
          dense
          return-object
          filled
          label="Pesquise uma escola"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <v-tabs
      v-model="tab"
      grow
      background-color="transparent"
      class="elevation-1 mb-6"
      color="primary"
    >
      <v-tab href="#turmas" class="text-capitalize">
        <v-icon left>groups</v-icon>
        Turmas
      </v-tab>
      <v-tab href="#relatorios" class="text-capitalize">
        <v-icon left>query_stats</v-icon>
        Relatórios
      </v-tab>
      <v-tab href="#documentos" class="text-capitalize">
        <v-icon left>description</v-icon>
        Documentos
      </v-tab>
      <v-tab href="#gestao" class="text-capitalize">
        <v-icon left>manage_accounts</v-icon>
        Gestão
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" class="mt-4">
      <!-- Turmas -->
      <v-tab-item value="turmas" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Todas as turmas - Todas as escolas-->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosPorUnidades(escola?.id)"
              :id="`card-todas-turmas`"
            >
              <v-card-title>
                <v-icon large left> groups </v-icon>
                <span class="title font-weight-light">Turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="escolasTurmasAlunos()"
              :id="`card-todas-escolas-turmas`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              :id="`aba_turmas.card_alunos_especiais_${escola.id}`"
              color="primary"
              @click="alunosNecessidadesEspeciais(escola.id)"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Relatório de Necessidades Especiais</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Turmas - Escola atual (sem alunos) - (Quant. alunos por turma)-->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="primary"
              @click="listarTurmasEscola(escola.id)"
              :id="`card-turmas-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >Escola atual (Quant. alunos por turma)</v-card-text
              >
            </v-card>
          </v-col>
          <!--  -->

          <!-- Todas as turmas - Todas as escolas (sem alunos) -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="listarTodasTurmas()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Todas as turmas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >Todas as escolas (Quant. alunos por turma)</v-card-text
              >
            </v-card>
          </v-col>
          <!--  -->

          <!-- Mapa de matrículas - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="mapaDeMatriculasEscolas()">
              <v-card-title>
                <v-icon large left>groups</v-icon>
                <span class="title font-weight-light">Mapa de matrículas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->
        </v-row>
      </v-tab-item>
      <!-- Fim - Turmas -->

      <!-- Relatórios -->
      <v-tab-item value="relatorios" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Relatório aulas - Relatório inserção de aulas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="insercaoAulas()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Aulas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Inserção de aulas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório alunos matriculados -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="alunosMatriculadosXls()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Estudantes (Planilha)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <!-- Relatório professores planilha -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="professoresPlanilhaXls()" :id="`card-todas-turmas`">
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Professores (Planilha)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>

          <!-- Relatório de faltas - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="relatoriosEvasao(escola?.id)"
              :id="`card-relatorio-faltas-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Faltas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de Faltas (Professores) -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="OpenModalProfessor()" :id="`card-relatorio-faltas`">
              <v-card-title>
                <v-icon large left>query_stats</v-icon>
                <span class="title font-weight-light">Relatório de Faltas</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"
                >(Professores) - Escola Atual</v-card-text
              >
            </v-card>
          </v-col>
          <!--  -->
        </v-row>
      </v-tab-item>
      <!-- Fim - Relatórios -->

      <!-- Documentos -->
      <v-tab-item value="documentos" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Boletins - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="boletinsFranquia(escola.id)"
              :id="`card-boletins-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>receipt_long</v-icon>
                <span class="title font-weight-light">Boletins</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Boletins - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="boletinsFranquiaAlunosTransferidos(escola.id)"
              :id="`card-boletins-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>receipt_long</v-icon>
                <span class="title font-weight-light">Boletins - Alunos Transferidos</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatórios BNCC - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="relatoriosBnccFranquia(escola.id)"
              :id="`card-relatorios-bncc-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>child_care</v-icon>
                <span class="title font-weight-light">Relatórios BNCC</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de planos lançados - Escola atual -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="primary"
              @click="relatorioDeListagemDosPlanosLancados(escola.id)"
              :id="`card-planos-lancados-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de planos lançados - Todas as escolas -->
          <v-col cols="12" sm="6" md="4" v-if="escola && escola.id">
            <v-card
              color="primary"
              @click="relatorioDeListagemDosPlanosLancadosGeral(escola.id)"
              :id="`card-planos-lancados-geral`"
            >
              <v-card-title>
                <v-icon large left>auto_stories</v-icon>
                <span class="title font-weight-light">Planos lançados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->
        </v-row>
      </v-tab-item>
      <!-- Fim - Documentos -->

      <!-- Gestão -->
      <v-tab-item value="gestao" class="pa-4" style="background-color: #efefef">
        <v-row style="background-color: #efefef">
          <!-- Relatório de lotação - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="lotacaoEscola(escola?.id)">
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola Atual </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório de lotação - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="lotacao()">
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório de lotação</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Professores por Escola - Visualizar todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card color="primary" @click="professoresTodasEscolas()">
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Professores por Escola</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">
                Visualizar todas as escolas
              </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Relatório Por escola (Censo) - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="relatoriosCensoFranquia(escola?.id)"
              :id="`card-relatorios-censo-escola-${escola.id}`"
            >
              <template slot="progress">
                <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> mdi-book-variant </v-icon>
                <span class="title font-weight-light">Relatório Por escola (Censo)</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual </v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Professores por disciplina - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="qtdProfessoresPorDisciplina()"
              :id="`card-professores-por-disciplina`"
            >
              <template slot="progress">
                <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
              </template>
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Professores por disciplina</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Alunos não matriculados - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosNaoMatriculados(escola?.id)"
              :id="`card-alunos-nao-matriculados-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Escola Atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Alunos não matriculados - Todas as escolas -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="alunosNaoMatriculadosGeral()"
              :id="`card-alunos-nao-matriculados-geral`"
            >
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Alunos não matriculados</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold">Todas as escolas</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <!-- Resumo movimento escolar - Escola atual -->
          <v-col cols="12" sm="6" md="4">
            <v-card
              color="primary"
              @click="resumoMovimentoEscolar(escola?.id)"
              :id="`card-resumo-movimento-escolar-escola-${escola.id}`"
            >
              <v-card-title>
                <v-icon large left> manage_accounts </v-icon>
                <span class="title font-weight-light">Resumo movimento escolar</span>
              </v-card-title>
              <v-card-text class="subtitle font-weight-bold"> Escola atual</v-card-text>
            </v-card>
          </v-col>
          <!--  -->

          <v-col cols="12" sm="6" md="4">
            <v-dialog v-model="modalSelecaoMes" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-card
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  id="card-relatorios-movimentacao-matricula"
                >
                  <template slot="progress">
                    <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
                  </template>
                  <v-card-title>
                    <v-icon large left> mdi-account-search </v-icon>
                    <span class="title font-weight-light">Movimentações de Matrículas</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold"> Todas as escolas </v-card-text>
                </v-card>
                <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on"> Click Me </v-btn> -->
              </template>

              <v-card>
                <v-card-title class="text-h5 grey primary d-flex justify-center">
                  Escolha o mês do relatório</v-card-title
                >

                <v-card-text class="text-center mt-6">
                  <v-btn-toggle
                    v-model="mesMovimentacaoMatricula"
                    v-for="mes in $constants.meses"
                    :key="mes.id"
                  >
                    <v-btn @click="relatoriosMovimentacaoMatricula(mes.id)" :value="mes">
                      {{ mes.descricao }}
                    </v-btn>
                  </v-btn-toggle>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="d-flex justify-end">
                  <v-btn text color="primary" @click="modalSelecaoMesUsoDoSistema = false">
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="user.permissao_especial || user.roleName == 'super-admin'"
          >
            <v-dialog v-model="modalSelecaoMesQtdUsoDoSistema" width="500">
              <template v-slot:activator="{ on, attrs }">
                <!-- @click="relatoriosUsoDoSistema(mes, escola.id)" -->
                <v-card
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  :id="`card-relatorios-uso-do-sistema-${escola.id}`"
                >
                  <template slot="progress">
                    <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
                  </template>
                  <v-card-title>
                    <v-icon large left> mdi-account-search </v-icon>
                    <span class="title font-weight-light">Relatório de Acessos ao Sistema</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold"> Escola atual (MÊS)</v-card-text>
                </v-card>
                <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on"> Click Me </v-btn> -->
              </template>

              <v-sheet>
                <v-card-title class="text-h5 grey primary d-flex justify-center">
                  <strong>Escolha o mês e tipo do relatório</strong>
                </v-card-title>
                <v-card-text class="text-center mt-6 justify-center">
                  <div style="max-width: 180px; width: 100%" class="mx-auto">
                    <div class="text-h6 text-center mt-4">Tipo de usuários</div>
                    <v-row class="justify-space-between">
                      <v-radio-group v-model="tipoRelatorioUso">
                        <v-radio label="Geral" value="geral"></v-radio>
                      </v-radio-group>

                      <v-radio-group v-model="tipoRelatorioUso">
                        <v-radio label="Semed" value="semed"></v-radio>
                      </v-radio-group>
                    </v-row>
                  </div>
                  <v-btn-toggle
                    v-model="mesQtdUsoDoSistema"
                    v-for="mes in $constants.meses"
                    :key="mes.id"
                    class="mt-2"
                  >
                    <v-btn
                      @click="relatoriosQtdUsoDoSistema(mes.id, escola.id, tipoRelatorioUso)"
                      :value="mes"
                      class="ma-1"
                    >
                      {{ mes.descricao }}
                      <!-- <v-icon>mdi-format-align-left</v-icon> -->
                    </v-btn>
                  </v-btn-toggle>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="d-flex justify-end">
                  <v-btn text color="primary" @click="modalSelecaoMesQtdUsoDoSistema = false">
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-sheet>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            v-if="user.permissao_especial || user.roleName == 'super-admin'"
          >
            <v-dialog v-model="modalSelecaoQtdUsoDoSistemaAnual" width="500">
              <template v-slot:activator="{ on, attrs }">
                <!-- @click="relatoriosUsoDoSistema(mes, escola.id)" -->
                <v-card
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  :id="`card-relatorios-uso-do-sistema-${escola.id}`"
                >
                  <template slot="progress">
                    <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
                  </template>
                  <v-card-title>
                    <v-icon large left> mdi-account-search </v-icon>
                    <span class="title font-weight-light">Relatório de Acessos ao Sistema</span>
                  </v-card-title>
                  <v-card-text class="subtitle font-weight-bold"> Escola atual (ANO) </v-card-text>
                </v-card>
              </template>

              <v-sheet>
                <v-card-title class="text-h5 grey primary d-flex justify-center">
                  <strong>Escolha o tipo de usuário</strong>
                </v-card-title>
                <v-card-text class="text-center mt-6 justify-center">
                  <div style="max-width: 180px; width: 100%" class="mx-auto">
                    <div class="text-h6 text-center mt-4">Tipo de usuários</div>
                    <v-row class="justify-space-between">
                      <v-radio-group v-model="tipoRelatorioUsoAnual">
                        <v-radio label="Geral" value="geral"></v-radio>
                      </v-radio-group>

                      <v-radio-group v-model="tipoRelatorioUsoAnual">
                        <v-radio label="Semed" value="semed"></v-radio>
                      </v-radio-group>
                    </v-row>
                  </div>
                  <v-btn
                    @click="relatoriosQtdUsoDoSistemaAnual(escola.id, tipoRelatorioUsoAnual)"
                    class="ma-1"
                  >
                    Gerar Relatório Anual
                  </v-btn>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="d-flex justify-end">
                  <v-btn text color="primary" @click="modalSelecaoQtdUsoDoSistemaAnual = false">
                    Fechar
                  </v-btn>
                </v-card-actions>
              </v-sheet>
            </v-dialog>
          </v-col>
        </v-row>
      </v-tab-item>
      <!-- Fim - Gestão -->
    </v-tabs-items>
    <!--  -->
    <v-row>
      <template v-if="dialog">
        <v-row justify="center">
          <v-dialog v-model="dialog" max-width="450">
            <v-card>
              <v-card-title class="text-h5"> Selecione o mês correspondente </v-card-title>

              <v-card-text>
                <v-row justify="center" class="mt-4">
                  <v-date-picker v-model="picker" type="month"></v-date-picker>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="relatoriosEvasaoProfessor(escola.id)"
                  >Gerar Relatório</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <!--  -->
      <!-- <v-col cols="12" xs="12" sm="12" md="6" lg="4">
        <v-card color="success" @click="inscritosCongresso()">
          <template slot="progress">
            <v-progress-linear color="primary" height="5" indeterminate></v-progress-linear>
          </template>
          <v-card-title>
            <v-icon large left> mdi-book-variant </v-icon>
            <span class="title font-weight-light">Inscritos no evento</span>
          </v-card-title>
          <v-card-text class="subtitle font-weight-bold"> Relatório </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>
    <e-modal-boletim-franquia
      :dialog="dialogBoletimFranquia"
      :franquia_id="franquia_id"
      :tipoRelatorio="tipoRelatorioBoletim"
      @dialogChange="dialogBoletimFranquia = $event"
    ></e-modal-boletim-franquia>
    <e-modal-falta-aluno-franquia
      :dialog="dialogFaltaAlunoFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogFaltaAlunoFranquia = $event"
    ></e-modal-falta-aluno-franquia>
    <e-modal-bncc-franquia
      :dialog="dialogBnccFranquia"
      :franquia_id="franquia_id"
      @dialogChange="dialogBnccFranquia = $event"
    ></e-modal-bncc-franquia>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Relatórios",
  data() {
    return {
      dialog: false,
      tab: null,
      dialogBoletimFranquia: false,
      dialogFaltaAlunoFranquia: false,
      picker: "",
      escola: {
        descricao: null,
        id: null,
      },
      modalSelecaoMes: false,
      franquia_id: null,
      mesMovimentacaoMatricula: null,
      modalSelecaoMesQtdUsoDoSistema: false,
      modalSelecaoQtdUsoDoSistemaAnual: false,
      mesQtdUsoDoSistema: null,
      mesSelecionadoUsoDoSistema: new Date().toISOString().substr(0, 7),
      tipoRelatorioUso: "geral",
      tipoRelatorioBoletim: "normal",
      tipoRelatorioUsoAnual: "geral",
      dialogBnccFranquia: false,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    ...mapGetters("Franquias", ["franquiasList", "carregandoFranquias"]),
  },
  methods: {
    async alunosPorUnidades(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosPorUnidadeEScolar(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacaoGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacao() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacao();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async lotacaoEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.lotacaoEscola(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async boletinsFranquia(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.tipoRelatorioBoletim = "normal";
        this.dialogBoletimFranquia = !this.dialogBoletimFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async boletinsFranquiaAlunosTransferidos(franquia_id) {
      try {
        this.franquia_id = franquia_id;
        this.tipoRelatorioBoletim = "transferidos";
        this.dialogBoletimFranquia = !this.dialogBoletimFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async relatoriosBnccFranquia(franquia_id) {
      try {
        this.$loaderService.open("Verificando turmas...");
        const turmasInfantis = await this.$services.turmasService.listarTurmasInfantisFranquia({
          franquia_id,
        });

        if (!turmasInfantis || turmasInfantis.length === 0) {
          this.$toast.danger("Não há turmas de infantil para selecionar nesta franquia");
          this.$loaderService.close();
          return;
        }

        this.franquia_id = franquia_id;
        this.dialogBnccFranquia = !this.dialogBnccFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async inscritosCongresso() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.inscritosCongresso();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async escolasTurmasAlunos() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.escolasTurmasAlunos();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async mapaDeMatriculasEscolas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.mapaDeMatriculasEscolas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async listarTodasTurmas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTodasTurmas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async listarTurmasEscola(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.listarTurmasFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async insercaoAulas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.insercaoAulas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async resumoMovimentoEscolar(fraquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.resumoMovimentoEscolar(fraquia_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatorioDeListagemDosPlanosLancados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancados(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatorioDeListagemDosPlanosLancadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatorioDeListagemDosPlanosLancadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    // async relatoriosEvasao(franquia_id) {
    //   try {
    //     this.$loaderService.open("Carregando dados...");
    //     await this.$services.relatoriosService.relatoriosEvasao(parseInt(franquia_id, 10));
    //   } catch (error) {
    //     this.$handleError(error);
    //   }
    //   this.$loaderService.close();
    // },

    async relatoriosEvasao(franquia_id) {
      try {
        this.franquia_id = franquia_id;

        this.dialogFaltaAlunoFranquia = !this.dialogFaltaAlunoFranquia;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    OpenModalProfessor() {
      this.dialog = true;
    },

    async relatoriosEvasaoProfessor(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        const picker = this.picker;
        const dataSemTraco = picker.replace(/-/g, "");
        await this.$services.relatoriosService.relatoriosEvasaoProfessor(
          parseInt(franquia_id, 10),
          dataSemTraco
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosNaoMatriculados(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculados(parseInt(franquia_id, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async alunosNaoMatriculadosGeral() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNaoMatriculadosGeral();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async qtdProfessoresPorDisciplina() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.qtdProfessoresPorDisciplina();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async relatoriosCensoFranquia(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosCensoFranquia(parseInt(franquia_id, 10));
      } catch (error) {
        this.$toast.danger("Não foi possível carregar a informação solicitada! Tente novamente!");
      }
      this.$loaderService.close();
    },
    async professoresTodasEscolas() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.professoresTodasEscolas();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async relatoriosMovimentacaoMatricula(mes) {
      this.modalSelecaoMes = false;
      this.mesMovimentacaoMatricula = null;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosMovimentacaoMatricula(mes);
      } catch (error) {
        this.$toast.danger("Não foi possível carregar a informação solicitada! Tente novamente!");
      } finally {
        this.$loaderService.close();
      }
    },

    async relatoriosQtdUsoDoSistema(mes, franquia_id, tipoRelatorioUso) {
      this.modalSelecaoMesQtdUsoDoSistema = false;
      this.mesQtdUsoDoSistema = null;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosQtdUsoDoSistema(
          mes,
          parseInt(franquia_id, 10),
          tipoRelatorioUso
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async relatoriosQtdUsoDoSistemaAnual(franquia_id, tipoRelatorioUsoAnual) {
      this.modalSelecaoQtdUsoDoSistemaAnual = false;
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.relatoriosQtdUsoDoSistemaAnual(
          parseInt(franquia_id, 10),
          tipoRelatorioUsoAnual
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    async alunosNecessidadesEspeciais(franquia_id) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosNecessidadesEspeciais(
          parseInt(franquia_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async alunosMatriculadosXls() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.alunosMatriculadosXls();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async professoresPlanilhaXls() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.professoresPlanilhaXls();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
  mounted() {
    this.$loaderService.open("Carregando dados...");
    this.escola = this.user.franquia;
    this.$loaderService.close();
  },
};
</script>

<style scoped>
.v-card {
  height: 100%;
  transition: all 0.8s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 8px !important;
  overflow: hidden;
  border-left: 4px solid transparent;
}

.v-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.08) !important;
}

.v-card.primary {
  border-left-color: var(--v-primary-base);
  background: linear-gradient(to right, #fff7e4, #ffffff);
}

.v-card.success {
  border-left-color: var(--v-success-base);
  background: linear-gradient(to right, #f0fff0, #ffffff);
}

.v-tabs {
  border-radius: 8px;
}

.v-tab {
  font-weight: 500;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.v-tab--active {
  font-weight: 600;
  background-color: rgba(255, 255, 255, 0.062);
}

.v-tab-item {
  padding: 8px 0;
}

.v-col {
  padding-bottom: 16px;
  padding-top: 8px;
}

@media (max-width: 960px) {
  .v-card__title {
    font-size: 1rem !important;
    padding: 12px !important;
  }

  .v-card__text {
    font-size: 0.875rem !important;
    padding: 0 12px 12px !important;
  }

  .v-tab {
    font-size: 0.75rem;
    min-width: auto;
    padding: 0 12px;
  }

  .v-tab .v-icon {
    font-size: 1.25rem !important;
    margin-right: 4px !important;
  }
}

.v-card:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity 0.3s;
}

.v-card:hover:before {
  opacity: 0.04;
}

.v-autocomplete {
  border-radius: 8px;
  overflow: hidden;
}

.v-row:not(:last-child) {
  margin-bottom: 16px;
}
</style>
